"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var esri_loader_1 = require("esri-loader");
var wildfires_1 = require("../../store/reducers/wildfires");
var FireflySymbolsLookup_1 = require("./FireflySymbolsLookup");
var WildfireLayer = function (_a) {
    var url = _a.url, definitionExpression = _a.definitionExpression, classBreakRendererInfo = _a.classBreakRendererInfo, mapView = _a.mapView, feature2FlyTo = _a.feature2FlyTo, feature2OpenPopup = _a.feature2OpenPopup, visibleFeaturesOnChange = _a.visibleFeaturesOnChange;
    var _b = React.useState(), wildfireLayer = _b[0], setWildfireLayer = _b[1];
    var init = function () { return __awaiter(void 0, void 0, void 0, function () {
        var FeatureLayer, _a, rendererForeground, rendererBackground, popupTemplate, labelClass, wildfireLayer, wildfireBackgroundLayer;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, esri_loader_1.loadModules([
                        'esri/layers/FeatureLayer'
                    ])];
                case 1:
                    FeatureLayer = (_b.sent())[0];
                    return [4, getRenderer()];
                case 2:
                    _a = _b.sent(), rendererForeground = _a[0], rendererBackground = _a[1];
                    return [4, getPopupTemplate()];
                case 3:
                    popupTemplate = _b.sent();
                    return [4, getLabelClass()];
                case 4:
                    labelClass = _b.sent();
                    wildfireLayer = new FeatureLayer({
                        url: url,
                        definitionExpression: definitionExpression,
                        renderer: rendererForeground,
                        popupTemplate: popupTemplate,
                        labelingInfo: [labelClass]
                    });
                    wildfireBackgroundLayer = new FeatureLayer({
                        url: url,
                        definitionExpression: definitionExpression,
                        renderer: rendererBackground,
                        labelsVisible: false,
                        popupEnabled: false
                    });
                    mapView.map.addMany([wildfireBackgroundLayer, wildfireLayer]);
                    wildfireLayer.when(function () {
                        setWildfireLayer(wildfireLayer);
                    });
                    return [2];
            }
        });
    }); };
    var getPopupTemplate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var FieldInfo, title, content, fieldInfos;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, esri_loader_1.loadModules([
                        'esri/popup/FieldInfo'
                    ])];
                case 1:
                    FieldInfo = (_a.sent())[0];
                    title = "Start Date: <b>{" + wildfires_1.WildfireFeatureFields.FireDiscoveryDateTime + "}</b>";
                    content = ("\n            <div>\n                The <b>{" + wildfires_1.WildfireFeatureFields.IncidentName + "} fire</b> in {" + wildfires_1.WildfireFeatureFields.POOState + "} is\n                estimated to be <b>{" + wildfires_1.WildfireFeatureFields.DailyAcres + "} acres</b>\n                and <b>{" + wildfires_1.WildfireFeatureFields.PercentContained + "}%</b> contained\n            </div>\n\n            <div class='leader-half'>\n                <a href='https://news.google.com/search?q={" + wildfires_1.WildfireFeatureFields.IncidentName + "} fire' class='margin-right-half' target='_blank'>News</a>\n                <a href='https://twitter.com/search?q={" + wildfires_1.WildfireFeatureFields.IncidentName + "} fire' class='margin-right-half' target='_blank'>Twitter</a>\n                <a href='https://www.facebook.com/search/top/?q={" + wildfires_1.WildfireFeatureFields.IncidentName + "} fire' target='_blank'>Facebook</a>\n            </div>\n        ").trim().replace(/(\r\n|\n|\r)/gm, "");
                    fieldInfos = [
                        new FieldInfo({
                            fieldName: wildfires_1.WildfireFeatureFields.FireDiscoveryDateTime,
                            format: {
                                dateFormat: 'short-date-short-time'
                            }
                        }),
                        new FieldInfo({
                            fieldName: wildfires_1.WildfireFeatureFields.DailyAcres,
                            format: {
                                places: 0,
                                digitSeparator: true
                            }
                        })
                    ];
                    return [2, {
                            title: title,
                            content: content,
                            fieldInfos: fieldInfos,
                            outFields: ["*"]
                        }];
            }
        });
    }); };
    var getRenderer = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, ClassBreaksRenderer, PictureMarkerSymbol, classBreakInfos, field, classBreaks, rendererForeground, rendererBackground;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, esri_loader_1.loadModules([
                        'esri/renderers/ClassBreaksRenderer',
                        'esri/symbols/PictureMarkerSymbol'
                    ])];
                case 1:
                    _a = _b.sent(), ClassBreaksRenderer = _a[0], PictureMarkerSymbol = _a[1];
                    classBreakInfos = classBreakRendererInfo.classBreakInfos, field = classBreakRendererInfo.field;
                    classBreaks = classBreakInfos.map(function (classBreak, index) {
                        var label = classBreak.label, classMaxValue = classBreak.classMaxValue;
                        return {
                            minValue: index === 0 ? 0 : classBreakInfos[index - 1].classMaxValue + .1,
                            maxValue: index === classBreakInfos.length - 1 ? 9999999999999 : classMaxValue,
                            symbol: null,
                            label: label
                        };
                    });
                    rendererForeground = new ClassBreaksRenderer({
                        field: field,
                        classBreakInfos: classBreaks.map(function (d, i) {
                            var _a = FireflySymbolsLookup_1.foregroundSymbols[i], url = _a.url, height = _a.height, width = _a.width;
                            d.symbol = new PictureMarkerSymbol({ url: url, height: height, width: width });
                            return d;
                        })
                    });
                    rendererBackground = new ClassBreaksRenderer({
                        field: field,
                        classBreakInfos: classBreaks.map(function (d, i) {
                            var _a = FireflySymbolsLookup_1.backgroundSymbols[i], url = _a.url, height = _a.height, width = _a.width;
                            d.symbol = new PictureMarkerSymbol({ url: url, height: height, width: width });
                            return d;
                        })
                    });
                    return [2, [rendererForeground, rendererBackground]];
            }
        });
    }); };
    var getLabelClass = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, LabelClass, TextSymbol;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, esri_loader_1.loadModules([
                        'esri/layers/support/LabelClass',
                        'esri/symbols/TextSymbol'
                    ])];
                case 1:
                    _a = _b.sent(), LabelClass = _a[0], TextSymbol = _a[1];
                    return [2, new LabelClass({
                            labelExpressionInfo: {
                                expression: "$feature." + wildfires_1.WildfireFeatureFields.IncidentName
                            },
                            symbol: new TextSymbol({
                                color: "#d18802 ",
                                haloColor: "#1a0011",
                                haloSize: 3,
                                font: {
                                    size: 9,
                                    weight: "bold"
                                }
                            }),
                            labelPlacement: 'below-center',
                            maxScale: 0,
                            minScale: 1390801
                        })];
            }
        });
    }); };
    var queryVisibleFeatures = function () { return __awaiter(void 0, void 0, void 0, function () {
        var uniqueIdField, features, uniqueIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    uniqueIdField = wildfires_1.WildfireFeatureFields.UniqueFireIdentifier;
                    return [4, wildfireLayer.queryFeatures({
                            geometry: mapView.extent,
                            where: definitionExpression,
                            outFields: [uniqueIdField],
                            returnGeometry: false
                        })];
                case 1:
                    features = (_a.sent()).features;
                    uniqueIds = features.map(function (f) { return f.attributes[uniqueIdField]; });
                    visibleFeaturesOnChange(uniqueIds);
                    return [2];
            }
        });
    }); };
    var openPopup = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, Point, Graphic, geometry, attributes, x, y, location_1, popupTemplate, featureGraphic, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!feature2OpenPopup) {
                        mapView.popup.close();
                        return [2];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4, esri_loader_1.loadModules([
                            'esri/geometry/Point',
                            'esri/Graphic'
                        ])];
                case 2:
                    _a = _b.sent(), Point = _a[0], Graphic = _a[1];
                    geometry = feature2OpenPopup.geometry, attributes = feature2OpenPopup.attributes;
                    x = geometry.x, y = geometry.y;
                    location_1 = new Point({
                        longitude: x,
                        latitude: y
                    });
                    return [4, getPopupTemplate()];
                case 3:
                    popupTemplate = _b.sent();
                    featureGraphic = new Graphic({
                        attributes: attributes,
                        popupTemplate: popupTemplate
                    });
                    mapView.popup.open({
                        location: location_1,
                        features: [featureGraphic]
                    });
                    return [3, 5];
                case 4:
                    err_1 = _b.sent();
                    console.error(err_1);
                    return [3, 5];
                case 5: return [2];
            }
        });
    }); };
    var addWatchEvent = function () { return __awaiter(void 0, void 0, void 0, function () {
        var watchUtils, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, esri_loader_1.loadModules([
                            'esri/core/watchUtils'
                        ])];
                case 1:
                    watchUtils = (_a.sent())[0];
                    watchUtils.whenTrue(mapView, 'stationary', function () {
                        queryVisibleFeatures();
                    });
                    return [3, 3];
                case 2:
                    err_2 = _a.sent();
                    console.error(err_2);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    React.useEffect(function () {
        if (mapView) {
            init();
        }
    }, [mapView]);
    React.useEffect(function () {
        if (mapView && wildfireLayer) {
            addWatchEvent();
        }
    }, [wildfireLayer]);
    React.useEffect(function () {
        if (mapView && feature2FlyTo) {
            var _a = feature2FlyTo.geometry, x = _a.x, y = _a.y;
            mapView.goTo({
                center: [x, y],
                zoom: 10
            });
        }
    }, [feature2FlyTo]);
    React.useEffect(function () {
        if (mapView && wildfireLayer) {
            openPopup();
        }
    }, [feature2OpenPopup]);
    return null;
};
exports.default = WildfireLayer;
